export default __webpack_public_path__ + "static/media/plus-btn.a7ee7400.svg";